import {
  SERVER_DATE_FORMAT,
  addDays,
  convertDateToServerFormat,
  formatInTimeZone,
  parseISO,
  zonedTimeToUtc,
} from 'src/utils/date';

const getPayPeriodTimeZone = (): string => 'UTC';

export const getPayPeriodToday = (now: Date = new Date()): string =>
  formatInTimeZone(now, getPayPeriodTimeZone(), SERVER_DATE_FORMAT);

export const addDaysToDate = (date: string, amount: number): string =>
  convertDateToServerFormat(addDays(parseISO(date), amount));

export const getPayPeriodEndsAt = (lastDay: string): Date =>
  zonedTimeToUtc(`${addDaysToDate(lastDay, 1)}T00:00:00`, getPayPeriodTimeZone());
